import _ from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getOfficeListReq,
  getOfficeListResClear,
  setCurrentView,
} from "../../redux/assignCourse/actions";
import { setCurrentFilterView } from "../../redux/reports/actions";
import { SessionKeys } from "../../utils/AppUtils";
import Select from "react-select";
import { useTranslation } from "react-i18next";
const ChooseOfficePeople = (props) => {
  const {
    selectedOfficeList,
    setSelectedOfficeList,
    isMobile,
    selectedBrokerageList,
    officeLabel,
    is_corporate,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const officeListRes = useSelector((state) => state.assignCourse.officeList);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [searchInput, setSearchInput] = useState("");
  const [officeList, setOfficeList] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [officeOptList, setOfficeOptList] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState([]);
  const [defaultValue, setDefaultValue] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // useEffect(() => {
  //   dispatch(getOfficeListResClear());
  //   if (selectedBrokerageList?.length === 0 && is_corporate) {
  //   } else {
  //     searchOffice();
  //   }
  //   setIsLoading(true);
  // }, [dispatch]);

  useEffect(() => {
    setIsLoading(true);
    if (selectedBrokerageList?.length === 0 && is_corporate) {
    } else {
      searchOffice();
    }
    setOfficeOptList([]);
    setOfficeList([]);
    setDefaultValue([]);
    setSelectedOfficeList([]);
  }, [selectedBrokerageList]);

  useEffect(() => {
    setSelectedCount(selectedOfficeList?.length);

    const newDefaultValue = selectedOfficeList.map((office) => ({
      value: office.office_id,
      label: office.office_name,
      count: office.user_count,
    }));

    setDefaultValue(newDefaultValue);
  }, [selectedOfficeList]);

  useEffect(() => {
    if (searchInput !== undefined && searchInput.length > 2) searchOffice();
    else setErrorMsg("");
  }, [searchInput]);

  const searchOffice = () => {
    // console.log('officeListRes1')
    dispatch(
      getOfficeListReq({
        module: "getOfficeListSearch",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          search: searchInput,
          brokerage: selectedBrokerageList,
          type: "report",
        },
      })
    );
  };

  useEffect(() => {
    // console.log('officeListRes: ', officeListRes)
    if (!_.isEmpty(officeListRes)) {
      setErrorMsg("");
      if (officeListRes?.status === "success") {
        const officeArr = officeListRes?.payload?.payload;
        setOfficeList(officeArr);
        setOfficeOptList(
          _.map(officeArr, (office) => {
            return {
              value: office.office_id,
              label: office.office_name,
              count: office.user_count,
            };
          })
        );
      } else {
        setOfficeList([]);
        setOfficeOptList([]);
        if (!_.isEmpty(searchInput) && searchInput?.length > 2) {
          setErrorMsg(t("No result found for your search."));
        } else {
          setErrorMsg("");
        }
      }
      setIsLoading(false);
    } else {
      setOfficeList([]);
      setErrorMsg("");
    }
  }, [officeListRes]);

  const selectItem = (index) => {
    let tempArr = _.cloneDeep(officeList);
    let selectedTempArray = _.cloneDeep(selectedOfficeList);
    selectedTempArray.push(tempArr[index]);
    setSelectedOfficeList(selectedTempArray);
    tempArr.splice(index, 1);
    setOfficeList(tempArr);
  };

  const removeItem = (index) => {
    let selectedTempArray = _.cloneDeep(selectedOfficeList);
    let tempArr = _.cloneDeep(officeList);
    tempArr.push(selectedTempArray[index]);
    setOfficeList(tempArr);
    selectedTempArray.splice(index, 1);
    setSelectedOfficeList(selectedTempArray);
  };

  const applyOffice = () => {
    if (!_.isEmpty(selectedOffice)) {
      setErrorMsg("");
      let data = [];
      for (let office of officeList) {
        for (let sO of selectedOffice) {
          if (sO.value === office.office_id) {
            data.push(office);
          }
        }
      }
      setSelectedOfficeList(data);
    } else {
      // setErrorMsg("Please select at lease one office.");
    }
  };

  return (
    <>
      <div className="chooseteams chooseppl">
        <div className="chooseteamate">
          <div className="headong d-flex justify-content-between">
            <h4>
              {t("Choose People from")} {officeLabel}
            </h4>{" "}
          </div>
          <div className="input-lear position-relative d-flex">
            <label for="peoplesearch" className="input__label">
              {t("Search")}
            </label>
            {/* <input type="text" id="peoplesearch" name="peoplesearch" className="input_searchfield_search-cart " placeholder="Start searching"
							onChange={(evt) => {
								setSearchInput(evt.target.value)
							}} /> */}
            <Select
              isMulti
              name="colors"
              className="basic-multi-select w-100 multi-label-select"
              classNamePrefix="xsel"
              options={officeOptList}
              value={defaultValue}
              isLoading={isLoading}
              onChange={(e) => {
                console.log(e);
                // setSelectedOffice(e)
                if (!_.isEmpty(e)) {
                  setErrorMsg("");
                  let data = [];
                  for (let office of officeList) {
                    for (let sO of e) {
                      if (sO.value === office.office_id) {
                        data.push(office);
                      }
                    }
                  }
                  setSelectedOfficeList(data);
                } else {
                  setSelectedOfficeList([]);
                  // setErrorMsg("Please select at lease one office.");
                }
              }}
            />
          </div>
          <p className="error-msg">{errorMsg}</p>
          {/* <div className="search-team-result">
						{
							officeList?.map((item, index) => {
								return <div className="team-result-box">
									<div className="userteamname">{item?.office_name} <span className="peoplecount">{item?.user_count} people</span></div>
									<div className="addteammate" onClick={() => { selectItem(index) }}>+</div>
								</div>
							})
						}
					</div>
					<div className="teamselected">
						<div className="selectresilt">Selected Offices<strong>({selectedCount})</strong></div>
						<div className="search-team-result slectedteammates">
							{selectedOfficeList?.map((item, index) => {
								return <div className="team-result-box">
									<div className="userteamname">{item?.office_name} <span className="peoplecount">{item?.user_count} people</span></div>
									<div className="addteammate" onClick={() => {
										// console.log('removeItem');
										removeItem(index)
									}}>+</div>
								</div>
							})}

						</div>
					</div> */}
          {false && (
            <div className="buttonsteammate">
              {false && (
                <button
                  type="button"
                  className="btn btn-primary btn-block back-button"
                  onClick={() => {
                    dispatch(setCurrentFilterView(1));
                  }}
                >
                  Back
                </button>
              )}
              <button
                type="button"
                className="btn btn-primary btn-block setup-button"
                onClick={() => {
                  // setSelectedOfficeList(selectedOfficeList)
                  applyOffice();
                  // dispatch(setCurrentFilterView(1))
                }}
              >
                Apply
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChooseOfficePeople;
